import { images } from "../../Assets/assetsHelper";
import "./Profile.css";
import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { BaseURL } from "../../Hooks/URL";
import Person3Icon from "@mui/icons-material/Person3";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate } from "react-router-dom";
import ApartmentIcon from "@mui/icons-material/Apartment";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";
import BadgeIcon from "@mui/icons-material/Badge";
import SchoolIcon from "@mui/icons-material/School";
import EditIcon from "@mui/icons-material/Edit";
import LockIcon from "@mui/icons-material/Lock";
import { MoonLoader, PulseLoader } from "react-spinners";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import FormModal from "../../Components/Molecules/FormModal/FormModal";
import ChangePasswordForm from "../../Components/Organisms/Forms/ChangePasswordForm/ChangePasswordForm";

function Profile({ loading, role, profile, PassOpen, setPassOpen }) {
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="mainContainer">
        <div className="loadingContainer">
          <MoonLoader color="#012369" size={40} />
        </div>
      </div>
    );
  }

  const getEditRoute = () => {
    if (role === "school") {
      return "/schools/me";
    } else if (role === "teacher") {
      return "/instructors/me";
    }
    return "#";
  };

  return (
    <div className="mainContainer">
      <FormModal
        Open={PassOpen}
        HandleClose={() => setPassOpen(false)}
        CustomStyle={"small"}
        Form={<ChangePasswordForm handleClose={() => setPassOpen(false)} />}
        Title={"Change Password"}
      />

      {profile && (
        <>
          {/* Action Buttons */}
          <div className="profileActions">
            {role != "admin" && (
              <button
                className="actionButton primary"
                onClick={() => navigate(getEditRoute())}
              >
                Edit Profile
              </button>
            )}
            <button
              className="actionButton secondary"
              onClick={() => setPassOpen(true)}
            >
              Change Password
            </button>
          </div>

          {/* About Section */}
          <div className="contentSection">
            <div className="profileHeader">
              <div className="profileLogoSection">
                {profile?.logoFilePath ? (
                  <img
                    src={`${BaseURL}/${profile?.logoFilePath}`}
                    alt="Profile Photo"
                    className="profileLogo"
                  />
                ) : (
                  <div className="profileLogoPlaceholder">
                    <Person3Icon style={{ fontSize: "64px" }} />
                  </div>
                )}
              </div>

              <div className="profileBasicInfo">
                <h1 className="profileName">{profile?.name}</h1>

                {profile?.website && (
                  <div className="profileWebsite">
                    <a
                      href={profile?.website}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {profile?.website}
                    </a>
                  </div>
                )}

                <div className="profileSocialLinks">
                  {profile?.facebook && (
                    <a
                      href={profile?.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="socialLink facebook"
                    >
                      <FacebookIcon />
                    </a>
                  )}
                  {profile?.instagram && (
                    <a
                      href={profile?.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="socialLink instagram"
                    >
                      <InstagramIcon />
                    </a>
                  )}
                  {profile?.whatsappLink && (
                    <a
                      href={profile?.whatsappLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="socialLink whatsapp"
                    >
                      <WhatsAppIcon />
                    </a>
                  )}
                </div>
              </div>
            </div>

            <h2 className="sectionTitle">Profile Details</h2>
            <div className="infoGrid">
              <div className="infoItem">
                <div className="infoLabel">
                  <EmailIcon className="infoIcon" />
                  Email
                </div>
                <div className="infoValue">{profile?.email}</div>
              </div>
              {profile?.phone && (
                <div className="infoItem">
                  <div className="infoLabel">
                    <PhoneIcon className="infoIcon" />
                    Phone Number
                  </div>
                  <div className="infoValue">{profile?.phone || "N/A"}</div>
                </div>
              )}
              {profile?.whatsappLink && (
                <div className="infoItem">
                  <div className="infoLabel">
                    <WhatsAppIcon className="infoIcon whatsapp" />
                    WhatsApp Number
                  </div>
                  <div className="infoValue">
                    +{profile?.whatsappLink?.split("=")?.at(1) || "N/A"}
                  </div>
                </div>
              )}

              {profile?.gender && (
                <div className="infoItem">
                  <div className="infoLabel">
                    {profile?.gender === "male" ? (
                      <MaleIcon className="infoIcon male" />
                    ) : (
                      <FemaleIcon className="infoIcon female" />
                    )}
                    Gender
                  </div>
                  <div className="infoValue">
                    {profile?.gender === "male" ? "Male" : "Female"}
                  </div>
                </div>
              )}
              {profile?.nationalId && (
                <div className="infoItem">
                  <div className="infoLabel">
                    <BadgeIcon className="infoIcon" />
                    National ID
                  </div>
                  <div className="infoValue">
                    {profile?.nationalId || "N/A"}
                  </div>
                </div>
              )}
              {profile?.country?.name && (
                <div className="infoItem">
                  <div className="infoLabel">Address</div>
                  <div className="infoValue">
                    {profile?.country?.name} / {profile?.city?.name} /{" "}
                    {profile?.street}
                  </div>
                </div>
              )}
              {profile?.active && (
                <div className="infoItem">
                  <div className="infoLabel">Status</div>
                  <div
                    className={`statusIndicator ${
                      profile?.active ? "active" : "inactive"
                    }`}
                  >
                    {profile?.active ? <DoneIcon /> : <CloseIcon />}
                    {profile?.active ? "Activated" : "Not Activated"}
                  </div>
                </div>
              )}
              {profile?.joinDate && (
                <div className="infoItem">
                  <div className="infoLabel">
                    <CalendarTodayIcon className="infoIcon" />
                    Join Date
                  </div>
                  <div className="infoValue">
                    {new Date(profile?.joinDate).toLocaleDateString()}
                  </div>
                </div>
              )}
            </div>

            {profile?.about && (
              <div className="aboutSection" style={{ marginTop: "20px" }}>
                <h3 className="aboutTitle">About the School</h3>
                <p className="aboutText">{profile?.about}</p>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default Profile;
